export const PERCENTAGE_BAND_COLORS_MONOCHROME = [
  'var(--purple-950)',
  'var(--purple-900)',
  'var(--purple-800)',
  'var(--purple-700)',
  'var(--purple-600)',
  'var(--purple-400)',
  'var(--purple-300)',
  'var(--purple-200)',
  'var(--purple-100)',
  'var(--purple-50)',
];

export const DEFAULT_START_INDEX = 4;

export const formatter = new Intl.NumberFormat('en-US', {});
export const usdFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
});

export const CATEGORY_TREE_COLUMN_VISIBILITY_STATE_KEY =
  'ls:ui:category-tree-column-visibility';
export const CATEGORY_TREE_COLUMN_WIDTH_STATE_KEY =
  'ls:ui:category-tree-column-width';
